import { styled } from 'styled-components';

const StatusCardStyle = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 180px;
  height: 240px;
  flex: none;
  padding: 0px 8px 8px 8px;
  flex-direction: column;
  justify-content: space-between;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  overflow: hidden;

  border-radius: 12px;
  background: ${(props) =>
    props.$level == 0
      ? 'radial-gradient(65.56% 49.17% at 50% 22.08%, rgba(212, 115, 50, 0.50) 0%, rgba(212, 115, 50, 0.00) 100%), #27262B'
      : props.$level == 1
        ? 'radial-gradient(65.56% 49.17% at 50% 22.08%, rgba(230, 179, 255, 0.25) 0%, rgba(149, 149, 149, 0.00) 100%), #27262B'
        : props.$level == 2
          ? 'radial-gradient(65.56% 49.17% at 50% 22.08%, rgba(255, 195, 0, 0.25) 0%, rgba(255, 195, 0, 0.00) 100%), #27262B'
          : 'radial-gradient(65.56% 49.17% at 50% 22.08%, rgba(110, 220, 255, 0.25) 0%, rgba(110, 220, 255, 0.00) 100%), #27262B'};
  @media (min-width: 768px) {
    width: 264px;
    height: 352px;
    flex: none;
  }
`;
const ActiveBg = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  &:after {
    content: '';
    inset: -50%;
    position: absolute;
    top: -85%;

    background-image: url('/images/icons/status/active_level_${(props) =>
      props.$level}.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    animation: rotate 10s linear 0s infinite;
  }
`;

const StatusCardContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 65%;
  align-items: center;
  justify-items: center;
  justify-content: flex-start;
  margin-top: 40px;
  flex-grow: 1;
  gap: 15px;
  @media (min-width: 768px) {
    margin-top: 52px;
    flex-grow: 1;
  }
`;
const StatusCardCrown = styled.div`
  width: 54px;
  height: 54px;
  background-image: url(${(props) => props['data-image-url']});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  @media (min-width: 768px) {
    width: 80px;
    height: 80px;
  }
`;
const StatusCardTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  text-align: center;
  text-shadow: 0px 1.412px 1.412px rgba(11, 21, 46, 0.5);
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%;

  opacity: ${(props) => (props.$isActive ? '1' : '0.5')};
  @media (min-width: 768px) {
    font-size: 32px;
  }
`;
const DetailField = styled.div`
  display: flex;
  height: 36px;
  padding: 6px 12px;
  justify-content: space-between;
  align-self: stretch;
  align-items: center;
  border-radius: 8px;
  background: #3d3c41;
  backdrop-filter: blur(8.810646057128906px);
  opacity: ${(props) => (props.$isActive ? '1' : '0.5')};
  flex-shrink: 0;
  @media (min-width: 768px) {
    height: 54px;
  }
`;
const DetailLabel = styled.div`
  color: #fff;
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-transform: capitalize;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;
const DetailValue = styled.div`
  color: #fff;
  text-align: center;
  text-shadow: 0px 1.412px 1.412px rgba(11, 21, 46, 0.5);
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%;
  @media (min-width: 768px) {
    font-size: 32px;
  }
`;

export {
  StatusCardStyle,
  ActiveBg,
  StatusCardContent,
  StatusCardCrown,
  StatusCardTitle,
  DetailField,
  DetailLabel,
  DetailValue,
};
